import { ComponentProps, PropsWithChildren } from 'react'
import { cn } from '../utils'
import { InfoIcon24 } from '../icons'

export interface InfoAlertProps extends ComponentProps<'div'> {
  'data-testid': string
}

export default function InfoAlert({
  'data-testid': testId,
  children,
  className
}: PropsWithChildren<InfoAlertProps>) {
  return (
    <div
      className={cn(
        'flex items-center gap-0.5 text-left border-blue-500 dark:border-blue-400 border-2 p-1 text-cool-gray-700 dark:text-cool-gray-200',
        className
      )}
      data-testid={testId}
    >
      <InfoIcon24 className="shrink-0" data-testid={`${testId}-icon`} />
      <div>{children}</div>
    </div>
  )
}
